export const apiUpdateSortOrder = "Account/UpdateSortOrder"
export const apiExportUser = "Account/ExportUser"
//Đơn vị
export const apiGetAccount = "Account/GetAccount"
export const apiUpdateByAccountID = "Account/UpdateByAccountID"
export const apiInsertAccount = "Account/InsertAccount"
export const apiDeleteAccount = "Account/DeleteAccount"
export const apiGetAccountFather = "Account/GetAccountFather"
export const apiGetChildAccountByParentID = "Account/GetChildAccountByParentID"
//Nhóm
export const apiGetGroupAccount = "Account/GetGroupAccount"
export const apiInsertGroupAccount = "Account/InsertGroupAccount"
export const apiUpdateGroupAccount = "Account/UpdateGroupAccount"
export const apiDeleteGroupAccount = "Account/DeleteGroupAccount"
//Thành viên
export const apiGetAllMember = "Account/GetAllMember"
export const apiInsertMember = "Account/InsertMember"
export const apiUpdateMember = "Account/UpdateMember"
export const apiDeleteMember = "Account/DeleteMember"
export const apiResetPassword = "Account/ResetPassword"
export const apiExportAccountMember = "Account/ExportAccountMember"
//Nhóm Thành viên
export const apiGetListMemberForGroup = "Account/GetListMemberForGroup"
export const apiInsertMemberToGroup = "Account/InsertMemberToGroup"
export const apiDeleteMemberGroup = "Account/DeleteMemberGroup"
//Mời hội viên
export const apiInsertUserAssociation = "Member/InsertUserAssociation"
export const apiGetMembersForCategory = "Member/GetMembersForCategory"
export const apiGetMembersForCategoryNotInAssociation = "Member/GetMembersForCategoryNotInAssociation"
//Mời email
export const apiInsertInvitedEmail = "Member/InsertInvitedEmail"